import { useCallback, useMemo } from "react";
import {
  SystemEmailMode,
  SystemEmailRegistryEntry,
} from "../../services/admin/systemEmails.service";

export function useSystemEmailModeOptions(holdable: boolean) {
  return useMemo(
    () => [
      { label: "On", value: "on" },
      { label: "Review", value: "review", disabled: !holdable },
      { label: "Off", value: "off", disabled: !holdable },
    ],
    [holdable]
  );
}

export function useSystemEmailModeSelection(
  entry: SystemEmailRegistryEntry,
  onOpen: (mode: SystemEmailMode) => void,
  onReset: () => void
) {
  return useCallback(
    (value: string) => {
      if (value === entry.mode) return;
      onReset();
      onOpen(value as SystemEmailMode);
    },
    [entry.mode, onOpen, onReset]
  );
}
